export default __webpack_public_path__ + "697621a0ffad58cd093a1c286e61ccf0.png";